import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=3ef687e8&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=3ef687e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef687e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef687e8')) {
      api.createRecord('3ef687e8', component.options)
    } else {
      api.reload('3ef687e8', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=3ef687e8&scoped=true&", function () {
      api.rerender('3ef687e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4R6NQuLgCqTqJ/JS/teamMember.vue"
export default component.exports